import { DEFAULT_FORMATS } from '../../../shared/models/default-formats.const';
import { UserPreferences } from './user-preferences.model';

export const DEFAULT_USER_PREFERENCES: UserPreferences = { ...DEFAULT_FORMATS,
    landingPage: 'system_navigation.MAINTAB_QUEUES',
    navigationBar: 'main_window.my_favorite',
};
